module.exports = __webpack_public_path__ + "static/media/YF81_4.c0ff8bb0.jpg";